export enum QualityColorEnum {
  A1 = 'A1',
  A2 = 'A2',
}
